/** @flow */
import type { State } from "@store/reducers";
import type { TrendsType } from "@modules/reporting/reducer/trends/types";
import type {
  ComplianceReport,
  ComplianceReportDetails,
  ComplianceReportViewState,
} from "@modules/reporting/reducer/trends/compliance/types";

import { enrichReportData } from "./report-enricher";

export const getCompliance = (state: State): $PropertyType<TrendsType, "compliance"> =>
  state.reporting.trends.compliance;

export const getDefaultReports = (state: State): Array<ComplianceReport> =>
  getCompliance(state).defaultReports || [];

export const getMyReports = (state: State): Array<ComplianceReport> =>
  getCompliance(state).myReports || [];

export const getReportData = (state: State): ComplianceReportDetails => getCompliance(state).report;

export const getEnrichedReportData = (state: State): ComplianceReportDetails => {
  return enrichReportData(getReportData(state));
};

export const getReportsSchema = (state: State): ?Object => getCompliance(state).schema;

export const getReportToSave = (state: State): ?ComplianceReport =>
  getCompliance(state).reportToSave;

export const getViewState = (state: State): ComplianceReportViewState =>
  state.reporting.trends.compliance.viewState;

export const isLoading = (state: State): boolean =>
  state.reporting.trends.compliance.requestsInProgress > 0;

export const isReportGenerateInProgress = (state: State): boolean =>
  state.reporting.trends.compliance.reportGenerateInProgress > 0;
